import { call, put, takeLatest } from 'redux-saga/effects';

import { DAS_GET_BASKET_FAILED } from '../../constants/errors';
import { basketTypes } from '../../store/basket';
import { createError } from '../../store/errors';
import { reloadBasket } from './helpers';

const { GET_BASKET } = basketTypes;

export const performGetBasket = function* performGetBasket({ payload }) {
  try {
    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      return;
    }
  } catch (error) {
    yield put(
      createError({
        code: DAS_GET_BASKET_FAILED,
      }),
    );
  }
};

export default takeLatest(GET_BASKET, performGetBasket);
